
import {
getAvailableBalance,
getRechargeConfig,
saveFun
} from "@/api/shoppingGold.js";
import {
getCookie
} from "@/utils/auth.js";
import {
isAlipayOrWechat
} from '@/utils/common.js'
import Api from '@/api.js';
import Alert from 'vux/src/components/alert/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'



export default {
data() {
return {
rechargeConfigList:[],//配置列表
selectId:"",//选择配置的id
selectServer:false,//选中服务须知
totalAmount:0,//当前可用金额
expireNum:"",//过期提示
expireTime:"",
saveBalance:false,//充值按钮是否可点
shwoLoading:false,
utmSource:"",//来源
showServer:false,//合同弹窗
recentExpireCouponName:"",//优惠券名称
recentExpireCouponEndDate:"",//优惠券名称
showGiftImg:false,
couponGiftImgUrl:"",//赠品图片
}
},
directives: {
TransferDom
},
components: {
Alert,
Confirm,
Toast,
Loading
},
created() {

},
mounted: function() {
this.utmSource = this.getQueryString("utm_source");

let first_utm_source = localStorage.getItem("first_utm_source")
if(first_utm_source == "" || first_utm_source == null || first_utm_source == "undefined"){
localStorage.setItem("first_utm_source",this.utmSource)
}
this.shwoLoading = true;
this.getAvailableBalanceFun();
this.getRechargeConfigFun();
},
methods: {

getAvailableBalanceFun(){
let that = this;
getAvailableBalance().then(res => {
console.log("返回--------", res)
if (res.code == 1) {
that.totalAmount = res.data.totalAmount;


if(res.data.rechargeList.length > 0){
that.expireNum = res.data.rechargeList[0].usableBounsAmount + res.data.rechargeList[0].usableRechargeAmount,
that.expireTime = res.data.rechargeList[0].expireTime;
}

if(res.data.recentExpireCoupon != null){
that.recentExpireCouponName = res.data.recentExpireCoupon.name;
that.recentExpireCouponEndDate = res.data.recentExpireCoupon.endDate;
}

}
that.shwoLoading = false;
})
},


getRechargeConfigFun(){
let that = this;
getRechargeConfig().then(res => {
console.log("返回--------", res)
if (res.code == 1) {
that.rechargeConfigList = res.data
}

if(res.data.length > 0){
that.selectId = res.data[0].id;
}


that.shwoLoading = false;
})
},


selectConfigFun:function(id){
this.selectId = id;
this.setSaveBtnFun();
},


selectServerFun:function(){
this.selectServer = !this.selectServer;
this.setSaveBtnFun();
},


saveBalanceFun:function(){

if(this.selectId == "" || !this.selectServer){
return;
}
let that = this;
let params = {
id:this.selectId,
utmSource:"商城H5" + this.utmSource
}
this.saveBalance = false;
this.shwoLoading = true;
saveFun(params).then(res => {
console.log("返回--------", res)
that.shwoLoading = false;
if(res.code == 1){
let method = isAlipayOrWechat();

if (method == "wx") {
location.href = Api.wechatcartGold + '?code=' + res.data;
} else {

location.href = Api.alicartGold + '?code=' + res.data;
}
}

})
},

shoppingGoldListFun:function(selectMenu){
this.$router.push({
path: '/shoppingGoldList',
query: {
selectMenu:selectMenu
}
})
},


gotoIndexFun: function() {
var ua = navigator.userAgent.toLowerCase();
if(ua.match(/MicroMessenger/i) == "micromessenger"){

wx.miniProgram.getEnv((res) => {
if (res.miniprogram) {

wx.miniProgram.navigateTo({
url: '/pages/newIndex/index'
});
} else {

window.location.href = window.location.protocol + "//" + window.location.host;
}
})
}else{
window.location.href = window.location.protocol + "//" + window.location.host;
}
},


setSaveBtnFun:function(){
if(this.selectId != '' && this.selectServer){
this.saveBalance = true;
}else{
this.saveBalance = false;
}
},


getQueryString: function(name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
var r = window.location.search.substr(1).match(reg);

if (r != null) {
return unescape(r[2]);
}
return null;
},


openServerFun:function(){
this.showServer = true;
},


closeServerFun:function(){
this.showServer = false;
},


showGiftImgFun:function(imgUrl){
this.couponGiftImgUrl = imgUrl;
this.showGiftImg = true;
},

closeGiftImgFun:function(){
this.couponGiftImgUrl = "";
this.showGiftImg = false;
},


gotoCouponFun:function(){
window.location.href = process.env.MYURL + "/user/toCoupons";
}
},
filters: {

dateFormat: function(dataStr) {
var time = new Date(dataStr);

function timeAdd0(str) {
if (str < 10) {
str = '0' + str;
}
return str
}
var y = time.getFullYear();
var m = time.getMonth() + 1;
var d = time.getDate();
var h = time.getHours();
var mm = time.getMinutes();
var s = time.getSeconds();
return y + '-' + timeAdd0(m) + '-' + timeAdd0(d) + " " + "" + timeAdd0(h) + ":" + timeAdd0(mm) + ":" + timeAdd0(s);
},

strToFixed: function(num1, num2) {
let total = num1 * num2;
if (total.toString().indexOf('.') > -1) {
let arr = total.toString().split('.');
let len = arr[1].length;
if (len > 0) {
return total.toFixed(2)
} else {
return total
}
} else {
return total
}
},

strAddToFixed: function(total) {
console.log("total---------", total)
if (total.toString().indexOf('.') > -1) {
let arr = total.toString().split('.');
let len = arr[1].length;
if (len > 0) {
return total.toFixed(2)
} else {
return total
}
} else {
return total
}
},


getYuan:function (value) {
var value = Math.round(parseFloat(value) * 100) / 10000;
var xsd = value.toString().split(".");
if (xsd.length == 1) {

return value;
}
if (xsd.length > 1) {
if (xsd[1].length < 2) {
value = value.toString() + "0";
}
return value;
}
}
}
}



// WEBPACK FOOTER //
// ./src/view/shoppingGold/shoppingGold.vue